import {
    SAVE_FOR_LATER_REQUEST,
    FETCH_SAVED_ITEMS_REQUEST,
    FETCH_SAVED_ITEMS_SUCCESS,
    FETCH_SAVED_ITEMS_ERROR,
    RESET_MOVE_SFL_CART_SUCCESS,
    VERTICAL_SFL_VIEW_ALL,
} from '../actionTypes/CartActionTypes';

export const saveForLaterCartItem = (payload) => ({
    type: SAVE_FOR_LATER_REQUEST,
    payload,
});

export const fetchSavedItems = (payload) => ({
    type: FETCH_SAVED_ITEMS_REQUEST,
    payload,
});

export const getSavedItemsSuccess = (payload) => ({
    type: FETCH_SAVED_ITEMS_SUCCESS,
    payload,
});

export const getSavedItemsError = (error) => ({
    type: FETCH_SAVED_ITEMS_ERROR,
    error,
});

export const resetSflToCartSuccess = () => ({
    type: RESET_MOVE_SFL_CART_SUCCESS,
});

export const showVerticalSflViewAll = (payload) => ({
    type: VERTICAL_SFL_VIEW_ALL,
    payload,
});

export default {
    saveForLaterCartItem,
    fetchSavedItems,
    getSavedItemsSuccess,
    getSavedItemsError,
    resetSflToCartSuccess,
    showVerticalSflViewAll,
};
